import React, {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';


export default function BookingPage(props) {

    const {setRegisterPage, calendarID} = props

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    

    return (
        <>
        <div className="schedule-open slide-in-bottom">
            <div onClick={() => setRegisterPage(false)} className="schedule-close"><i class="far fa-chevron-left"></i> Back</div>
            <div className="schedule-inside-2">
            <iframe className="schedule" src={`https://app.acuityscheduling.com/schedule.php?owner=17444389&appointmentType=${calendarID}`} title="Schedule Appointment" width="100%" height="800" frameBorder="0"></iframe><script src="https://embed.acuityscheduling.com/js/embed.js" type="text/javascript"></script>
        </div>
        </div>
        </>
    )
}